var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1581_4818)","key":0},[React.createElement("path",{"d":"M7.19434 7.19409L20.8061 20.8059","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.19434 20.8059L20.8061 7.1941","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1581_4818"},React.createElement("rect",{"width":"28","height":"28","fill":"white"})))]);
}

Close.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Close;

Close.default = Close;
